<nav class="breadcrumb-nav">
  @for (crumb of breadcrumbs; track crumb.url; let last = $last) {
    @if (!last) {
      <span
        class="breadcrumb-item breadcrumb-item--parent"
        (click)="navigate(crumb.url)"
      >
        {{ crumb.label | translate }}
      </span>
      <span class="breadcrumb-separator"
        ><mat-icon>chevron_right</mat-icon></span
      >
    }
    @if (last) {
      <span class="breadcrumb-item breadcrumb-item--current">
        {{ crumb.label | translate }}
      </span>
    }
  }
</nav>
